// mobile menu
jQuery(function($){
  $(document).on("click",'.close-dropdown',function() {
    console.log('work');
    $(this).parents('.mobile-menu__list-item').siblings().find('input').prop('checked',false);
  });
});


// faq extend js from z__jsFAQ.js

// Shopify.theme.jsFAQ = {
//   init: function() {

//     const $faqHeading_custom = $('.faq  .accordion__button');
//     $faqHeading_custom.on('click',function(){
//         $(this).parent().next().siblings('dd').hide();
//         $(this).parent().next().siblings('dd').removeClass('active');
//         $(this).parent().siblings('dt').removeClass('active');
//         $(this).parent().addClass('active');
//         $(this).parent().next().addClass('active');  
//     });
//   }
// }


jQuery(function($){
  $(document).ready(function() {
    var field_location = $('#field_location');
    var findbutton = $('#findbutton');
    findbutton.click(function() {
      var correctPassword = "bunny";
      var getValue = field_location.val().toLowerCase() ;
      if(getValue == correctPassword ){
        $('.error').hide();
        window.location.href="https://www.tontine.com.au/pages/easter-egg-hunt-success";
      }else{
      $('.error').show();
      }
    });
  });
  
  $("#personalised-messagegift-messages").change(function () {
   $("#personalised-messagegift-message").toggle();
  });
});